import React from 'react';
import { APIS_URL, FACEBOOK_URL, INSTAGRAM_URL, X_URL, APP_VERSION } from "../../model/Config";

const Footer = ({ userSession }) => {
  const currentYear = new Date().getFullYear();
  const HOST_URL = APIS_URL;

  return (
    <footer>
      <div className="footer-section" style={{ padding: '15px 0 10px 0' }}>
        <div className="container-fluid">
          <div className="row" style={{ marginTop: '10px' }}>
            {/* Company Section */}
            <div className="col-md-2 col-6">
              <h5 className="footer-heading" style={{ color: '#A0A0A0', fontWeight: '600', fontSize: '16px', marginBottom: '10px' }}>Company</h5>
              <ul className="list-unstyled footer-links">
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/about-us" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>About Us</a></li>
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/contact-us" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>Contact Us</a></li>
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/customer-support" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>Customer Support</a></li>
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/faq" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>FAQ</a></li>
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/sitemap" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>Sitemap</a></li>
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href={HOST_URL} target="_blank" rel="noreferrer" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>Host Login</a></li>
              </ul>
            </div>

            {/* Policies Section */}
            <div className="col-md-2 col-6">
              <h5 className="footer-heading" style={{ color: '#A0A0A0', fontWeight: '600', fontSize: '16px', marginBottom: '10px' }}>Policies</h5>
              <ul className="list-unstyled footer-links">
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/privacy" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>Privacy Policy</a></li>
                <li style={{ lineHeight: '1.4', marginBottom: '4px' }}><a href="/terms-and-conditions" className="text-decoration-none" style={{ color: '#A0A0A0', fontSize: '14px' }}>Terms & Conditions</a></li>
              </ul>
            </div>

            {/* Social Section */}
            <div className="col-md-2 col-6">
              <h5 className="footer-heading" style={{ color: '#A0A0A0', fontWeight: '600', fontSize: '16px', marginBottom: '10px' }}>Social</h5>
              <div className="d-flex flex-column" style={{ alignItems: 'flex-start', gap: '6px' }}>
                <a href={X_URL} target='_blank' rel="noreferrer" className="text-decoration-none" style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center' }}>
                  <img src={`${process.env.PUBLIC_URL}/img/twitter.png`} alt="X" style={{ width: '28px', height: '28px' }} />
                </a>
                <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer" className="text-decoration-none" style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center' }}>
                  <img src={`${process.env.PUBLIC_URL}/img/instagram.png`} alt="Instagram" style={{ width: '28px', height: '28px' }} />
                </a>
                <a href={FACEBOOK_URL} target='_blank' rel="noreferrer" className="text-decoration-none" style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center' }}>
                  <img src={`${process.env.PUBLIC_URL}/img/facebook-square.svg`} alt="Facebook" style={{ width: '28px', height: '28px' }} />
                </a>
              </div>
            </div>


            {/* Security Badges & Payment Methods */}
            <div className="col-lg-6 col-md-6 col-12 footer-right-area" style={{ textAlign: 'right' }}>
              <div className="d-flex flex-column" style={{ alignItems: 'flex-end' }}>
                {/* Security Badges Row */}
                <div className="d-flex align-items-center mb-2" style={{ gap: '15px' }}>
                  <span style={{ display: 'inline-block', width: '52px', height: '64px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/cyber-essentials-seeklogo 1.svg`} alt="Cyber Essentials" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  </span>
                  <span style={{ display: 'inline-block', width: '75px', height: '75px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/GDPR.jpg`} alt="GDPR" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  </span>
                  <span style={{ display: 'inline-block', width: '49.99px', height: '66.14px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/SSL.jpeg`} alt="SSL Secure" style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }} />
                  </span>
                </div>

                {/* Payment Icons Row */}
                <div className="d-flex flex-wrap align-items-center mb-2 payment-icons-wrapper" style={{ gap: '8px', maxWidth: '500px', justifyContent: 'flex-end' }}>
                  <span className="payment-icon" style={{ width: '40px', height: '40px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/apple-pay-svgrepo-com.svg`} alt="Apple Pay" style={{ maxWidth: '100%', maxHeight: '100%', width: '100%', height: 'auto', objectFit: 'contain' }} />
                  </span>
                  <span className="payment-icon" style={{ width: '44px', height: '20.99px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/Gpay.png`} alt="Google Pay" style={{ maxWidth: '100%', maxHeight: '100%', width: '100%', height: 'auto', objectFit: 'contain' }} />
                  </span>
                  <span className="payment-icon" style={{ width: '40px', height: '45px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/Visa.webp`} alt="Visa" style={{ maxWidth: '100%', maxHeight: '100%', width: '100%', height: 'auto', objectFit: 'contain' }} />
                  </span>
                  <span className="payment-icon" style={{ width: '34px', height: '25px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/mastercard-svgrepo-com.png`} alt="Master Card" style={{ maxWidth: '100%', maxHeight: '100%', width: '100%', height: 'auto', objectFit: 'contain' }} />
                  </span>
                  <span className="payment-icon" style={{ width: '38px', height: '37px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/AMEX.png`} alt="Amex" style={{ maxWidth: '100%', maxHeight: '100%', width: '100%', height: 'auto', objectFit: 'contain' }} />
                  </span>
                  <span className="payment-icon" style={{ width: '40px', height: '40px' }}>
                    <img src={`${process.env.PUBLIC_URL}/img/Bank.svg`} alt="Bank Transfer" style={{ maxWidth: '100%', maxHeight: '100%', width: '100%', height: 'auto', objectFit: 'contain' }} />
                  </span>
                </div>

                {/* Copyright */}
                <div style={{ color: '#888', fontSize: '14px', fontWeight: '400', paddingTop: '10px' }}>
                  © Simply Halls, 2026 | Version {APP_VERSION}
                </div>
              </div>

              <style>{`
                .payment-icon {
                  display: inline-flex;
                  align-items: center;
                  justify-content: center;
                  overflow: hidden;
                }
                .payment-icon img {
                  max-width: 100% !important;
                  max-height: 100% !important;
                  width: 100% !important;
                  height: auto !important;
                  object-fit: contain !important;
                }
                @media (max-width: 767px) {
                  .footer-right-area {
                    text-align: left !important;
                    margin-top: 20px;
                  }
                  .footer-right-area > .d-flex.flex-column {
                    align-items: flex-start !important;
                  }
                  .footer-right-area .d-flex.align-items-center {
                    justify-content: flex-start !important;
                  }
                  .footer-right-area .payment-icons-wrapper {
                    justify-content: flex-start !important;
                  }
                }
              `}</style>
            </div>
          </div>


        </div>
        {/* Bottom Section with Registered Address */}
        <div style={{ borderTop: '1px solid #d1d1d1', borderBottom: '1px solid #d1d1d1', marginTop: '12px', padding: '8px 0' }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="d-flex justify-content-center">
                  <p className="text-center mb-0" style={{ color: '#000', fontSize: '14px', fontWeight: '400', letterSpacing: '0.2px' }}>
                    Registered Address: GKR Solutions Limited, 55, Chessfield Park, Amersham, HP6 6RU &nbsp; Company Number: 09934200 &nbsp;
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
